import { formatNumber as acFormatNumber, formatMoney as acFormatMoney} from "accounting-js/lib/index";

import NumberFormatInformation from "./NumberFormatInfo";


const _decimalSymbol = ".";
const _digitGroupingSymbol = ",";
const _percentageSymbol = "%";
const _currencySymbol = "";
const _invalidDoubleText = "";
const _emptyText = "";
const _missingValue = "-";
const _emptyValue = "";
const _numberOfDigitsAfterDecimal = "";
const _zero = "0";

function formatNumber(number, precision) {
    let returnV = acFormatNumber(number, {
        precision: precision,
        thousand: ",",
        decimal: "."
    });
    return returnV;
}

function formatMoney(number, precision) {
    let returnV = acFormatNumber(number, {
        precision: precision,
        thousand: ",",
        decimal: "."
    });
    return returnV.replace("$", "");
}

function formatNumberToCurrency(number, precision) {
    let returnV = acFormatNumber(number, {
        precision: precision,
        thousand: ",",
        decimal: "."
    });
    return returnV;
}

function isNan(value) {
    if (value == undefined)
        return false;

    if (value.toString().toLocaleUpperCase() == 'NAN')
        return true;

    return false;
}

function isError(value) {
    if (value == undefined)
        return false;
    if (value.toString().toLocaleUpperCase() == '#ERROR')
        return true;
    return false;
}

function doubleParseNative(value) {

    if (value == undefined)
        return 'invalid';

    if (isNan(value))
        return 'invalid';

    if (isError(value))
        return 'invalid';

    return acFormatNumber(value, NumberFormatInformation.DecimalSymbol);
}

function double(value, precision) {
    if (value == undefined) {
        return _missingValue;
    }
    if (value == 'missing') {
        return _missingValue;
    }


    if (value == null) {
        return _emptyValue
    }
    if (value == "" && value != 0) {
        return _emptyValue
    }
    if (value == "NaN") {
        return _emptyValue
    }
    if (typeof value === 'string') {
        return value;
    }
    // if (!value) {
    //     return _emptyValue
    // }



    value = doubleParseNative(value);

    if (value == "invalid")
        return NumberFormatInformation.InvalidDoubleText;

    if (precision == undefined)
        precision = 2;


    let doubletext = acFormatMoney(value, { symbol: "", precision: precision, thousand: _digitGroupingSymbol, decimal: _decimalSymbol })
    doubletext = doubletext.replace("NaN.undefined", acFormatMoney(0.0, { symbol: "", precision: precision, thousand: _digitGroupingSymbol, decimal: _decimalSymbol }));
    return doubletext;
}

function millionShort(value, precision) {
    if (value == undefined) {
        return _missingValue;
    }
    if (value == 'missing') {
        return _missingValue;
    }
    if (value == null) {
        return _emptyValue
    }
    if (value == "" && value != 0) {
        return _emptyValue
    }
    if (value == "NaN") {
        return _emptyValue
    }
    value = doubleParseNative(value);
    if (value == "invalid")
        return _invalidDoubleText;

    if (precision == undefined)
        precision = _numberOfDigitsAfterDecimal;

    // Değer string mi diye kontrol et
    let num;
    if (typeof value === 'string') {
        num = parseFloat(value);
    } else {
        num = value;
    }

    const formattedNum = parseFloat(value);
    var numberInMillions = formattedNum / 1000000; // 4563.874
    return numberInMillions;
}

function doubleNumber(value, precision) {
    if (value == undefined) {
        return _missingValue;
    }
    if (value == 'missing') {
        return _missingValue;
    }
    if (value == null) {
        return _emptyValue
    }
    if (value == "" && value != 0) {
        return _emptyValue
    }
    if (value == "NaN") {
        return _emptyValue
    }
    value = doubleParseNative(value);
    if (value == "invalid")
        return _invalidDoubleText;

    if (precision == undefined)
        precision = _numberOfDigitsAfterDecimal;

    // Değerin string olup olmadığını kontrol et ve formatla
    let formattedValue;
    formattedValue = double(value, precision);
    formattedValue = parseFloat(formattedValue);
    return formattedValue;
}

export { formatNumber, formatMoney, formatNumberToCurrency, isNan, isError, doubleParseNative, double, millionShort, doubleNumber};
